var lists_default = {
  "fontElementMap": "wPOTC",
  "orderedlist": "n8bau",
  "bulletedlist": "QOI7n",
  "listItem": "B229E"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
